export class ResourceOutsourceSearchRequest {

    _term; // string
    _onlyActive; // boolean

    constructor() {
        this._term = '';
        this._onlyActive = true;
    }

    setTerm(term) {
        this._term = term;
    }

    body() {
        return {
            criteria: {
                term: this._term,
                only_active: this._onlyActive,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-outsource/ResourceOutsourceSearchRequest.js